module.exports = __webpack_public_path__ + "img/库位库存.76943acc.svg";